/**
 * Customers module — the shapes the API returns and accepts.
 *
 * A customer is a person (walk-in) or a business (dealer, fleet) a shop does
 * work for. It belongs to the store that added it, or to every store in the
 * account when shared. The module is optional: an account switches it on
 * with the `customers` account feature, and every customers endpoint answers
 * 404 CUSTOMERS_OFF while it is off.
 */
/** The account feature key that switches the module on. */
export const CUSTOMERS_FEATURE = 'customers';
export const CUSTOMER_KINDS = ['person', 'business'];
export const CUSTOMER_PAYER_TYPES = ['customer_pay', 'insurance', 'fleet'];
